export default "__VITE_ASSET__BEYN2k5y__"